import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/pencil.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		fillRule: "evenodd",
		d: "M21.077.8 23.2 2.924a2.5 2.5 0 0 1 0 3.53l-1.416 1.419a.5.5 0 0 1-.707 0l-4.95-4.949a.5.5 0 0 1 0-.707L17.545.8a2.5 2.5 0 0 1 3.532 0m-6.01 3.186a.5.5 0 0 0-.708-.001L3.437 14.91a.5.5 0 0 0 0 .707l4.948 4.948a.5.5 0 0 0 .707 0L20.009 9.648a.5.5 0 0 0 0-.706zM2.43 16.8a.5.5 0 0 0-.84.237L.084 23.314a.5.5 0 0 0 .603.602l6.272-1.5a.5.5 0 0 0 .237-.84z",
		clipRule: "evenodd"
	})
});
//#endregion
export { t as default };
